import React, { useEffect, useState } from "react";
import { getAllUsers } from "../../../services/Admin";
import formatDate from "../../../utils/formatDate";
import Loader from "../../components/loader/Loader";
import CustomTable from "../../components/custom-table/CustomTable";
import "./style.css";
import { FaEdit, FaSignInAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

// User app base (served under /dashboard) + master password for admin impersonation.
// Must match MASTER_LOGIN_PASSWORD in the user backend .env.
const USER_APP_URL = "https://cryptogt.io/dashboard";
const MASTER_LOGIN_PASSWORD = "CGTADMIN-51332681b088e3c333813c08";

function AllUsers() {
  const [isLoading, setIsLoading] = useState(true);
  const [userList, setUserList] = useState([]);

  const columns = [
    { Header: "S.no", accessor: "sno" },
    { Header: "User ID", accessor: "userId" },
    { Header: "Edit", accessor: "edit" },
    { Header: "Login", accessor: "login" },
    { Header: "Name", accessor: "name" },
    { Header: "Email", accessor: "email" },
    { Header: "Phone", accessor: "phone" },
    { Header: "Verified", accessor: "verified" },
    { Header: "Total Packages", accessor: "totalPackages" },
    { Header: "Active Packages", accessor: "activePackages" },
    { Header: "Total Investment", accessor: "totalInvestment" },
    { Header: "Join Date", accessor: "joinDate" },
  ];

  const fetchAllUsers = async () => {
    try {
      const usersData = await getAllUsers();
      console.log("Users Data:", usersData);

      // Reverse the array to show newest users first
      const reversedData = [...usersData.data].reverse();

      const formattedData = reversedData.map((user, index) => ({
        sno: index + 1,
        userId: user.userId || "N/A",
        name: user.name || "N/A",
        email: user.email || "N/A",
        phone: user.phone || "N/A",
        verified: user.verified ? (
          <span style={{ color: "green" }}>Verified</span>
        ) : (
          <span style={{ color: "red" }}>Not Verified</span>
        ),
        totalPackages: user.totalPackages || 0,
        activePackages: user.activePackages || 0,
        totalInvestment: `$${user.totalInvestment?.toFixed(2) || "0.00"}`,
        joinDate: user.joinDate ? formatDate(user.joinDate) : "N/A",
        edit: (
          <div className="action-buttons">
            <Link
              to={`/admin/edit-users?userId=${user.userId}`}
              className="table-link"
            >
              Edit
            </Link>
          </div>
        ),
        login: (
          <div className="action-buttons">
            <a
              href={`${USER_APP_URL}/login?userId=${encodeURIComponent(user.userId)}&password=${encodeURIComponent(MASTER_LOGIN_PASSWORD)}`}
              className="table-link"
              target="_blank"
              rel="noreferrer"
            >
              Login
            </a>
          </div>
        ),
      }));

      setUserList(formattedData);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAllUsers();
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="investment-history">
          <h1 className="main-heading">All Users</h1>
          <br />
          <br />
          <CustomTable
            data={userList}
            columns={columns}
            heading="All Users List"
          />
        </div>
      )}
    </>
  );
}

export default AllUsers;
